// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  min-height: 100%;
  max-height: 100%;
  box-sizing: border-box;
  padding: 14px 18px 10px;
  overflow: hidden;
}

.message-content {
  color: rgb(73, 73, 73);
  display: block;
  padding: 0;
  text-align: center;
  line-height: 1.35;
  word-break: break-word;
  margin-top: -2px;
}

.action-container {
  width: 100%;
  padding-top: 4px;
}

.dialog-container .action-container {
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  display: flex;
  flex-wrap: wrap;
}

.header {
  padding: 0 8px;
  text-align: center;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.25;
  color: #3f3f3f !important;
}

.dialog-body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding-right: 4px;
}

.reason-field {
  width: 100%;
}

.reason-field textarea {
  resize: vertical;
}

::ng-deep .reason-field .mat-mdc-text-field-wrapper,
::ng-deep .reason-field .mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background: #f7f8fa;
  border: 1px solid #e1e5ea;
  border-radius: 6px;
  padding: 2px 10px 0;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}
::ng-deep .reason-field .mat-mdc-text-field-wrapper:hover,
::ng-deep .reason-field .mdc-text-field--filled:not(.mdc-text-field--disabled):hover {
  background: #f7f8fa;
  border-color: #cfd6df;
}
::ng-deep .reason-field .mat-mdc-form-field-focus-overlay,
::ng-deep .reason-field .mdc-line-ripple {
  display: none;
}
::ng-deep .reason-field .mat-mdc-form-field-flex {
  min-height: 92px;
}
::ng-deep .reason-field .mat-mdc-form-field-infix {
  padding: 22px 8px 12px;
}
::ng-deep .reason-field .mdc-floating-label,
::ng-deep .reason-field .mdc-floating-label--float-above {
  transition: none !important;
}
::ng-deep .reason-field .mdc-floating-label {
  left: 8px !important;
}
::ng-deep .reason-field .mdc-text-field--focused {
  background: #ffffff;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(var(--primary-rgb), 0.12);
}
::ng-deep .reason-field .mat-mdc-input-element {
  color: #242424;
  line-height: 1.35;
  padding-left: 0;
}
::ng-deep .reason-field .mat-mdc-input-element::placeholder {
  color: #7a7f87;
}

.dialog-container mat-accordion {
  display: block;
  margin-top: 4px;
}

.dialog-container mat-expansion-panel {
  border-radius: 6px !important;
}

::ng-deep .mat-expansion-panel-content,
::ng-deep .mat-expansion-panel-body {
  overflow: visible !important;
  padding: 0 !important;
}

.panel-header {
  font-weight: 400;
}

.section-header {
  font-weight: 600;
}

.expansion-icon {
  width: 20px;
  color: var(--primary-light);
}

.mat-expansion-panel-header {
  color: rgb(85, 85, 85);
  height: 24px;
  --mat-expansion-header-collapsed-state-height: 24px !important;
  font-size: 15px;
}

.mat-expansion-panel-header-title .material-icons {
  color: var(--primary-light);
  font-size: 20px !important;
}

.mat-expanded > mat-expansion-panel-header .mat-expansion-panel-header-title .material-icons {
  transform: rotate(90deg);
}

.mat-expansion-panel-header-title .open,
.mat-expanded .mat-expansion-panel-header-title .close {
  display: inline-block;
}

.mat-expanded .mat-expansion-panel-header-title .open,
.mat-expansion-panel-header-title .close {
  display: none;
}

.btn-footer {
  color: var(--primary);
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  z-index: 5;
  margin: 0;
  padding: 0 16px;
  font-size: 16px !important;
  text-transform: uppercase !important;
  transition: all 0.2s ease;
}

.btn-footer .mdc-button__label {
  text-transform: inherit;
}

.btn-footer:hover {
  background: rgba(var(--primary-rgb), 0.05);
}

::ng-deep .dialog-container app-table .table-container {
  margin: 8px 0 0;
  width: 100%;
  padding-bottom: 0;
}

::ng-deep .dialog-container app-table .table-action-container {
  margin-top: 0;
}

::ng-deep .dialog-container app-table .table {
  max-height: 400px !important;
  /* Move scroll inside the table */
  overflow-y: auto !important;
  overflow-x: hidden !important;
  /* Thin Scrollbar Styling */
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}
::ng-deep .dialog-container app-table .table::-webkit-scrollbar {
  width: 6px;
}
::ng-deep .dialog-container app-table .table::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::ng-deep .dialog-container app-table .table::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
  cursor: pointer;
}
::ng-deep .dialog-container app-table .table::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Standardized Sticky Header for Table */
::ng-deep .dialog-container app-table .mat-mdc-header-row {
  height: 22px !important;
  font: 600 11px/13px Lato !important;
  background-color: #d9d9d9 !important;
  color: #4a4a4a !important;
  position: sticky !important;
  top: 0;
  z-index: 100 !important;
}
::ng-deep .dialog-container app-table th.mat-mdc-header-cell {
  padding: 0px 5px !important;
  font: 600 11px/13px Lato !important;
  color: #4a4a4a !important;
  background-color: #d9d9d9 !important;
  position: sticky;
  top: 0;
  z-index: 100;
  overflow: hidden;
  vertical-align: middle;
}
::ng-deep .dialog-container app-table th.mat-mdc-header-cell:after {
  content: "";
  border-right: 1px solid rgb(201, 201, 201);
  position: absolute;
  display: block;
  height: calc(100% - 10px);
  top: 5px;
  bottom: 0px;
  right: 0;
}
::ng-deep .dialog-container app-table th.mat-mdc-header-cell:last-child::after {
  border-right: 1px solid transparent;
}
::ng-deep .dialog-container app-table .mat-mdc-row {
  height: 12px !important;
}
::ng-deep .dialog-container app-table .mat-mdc-row:nth-child(even) {
  background-color: #F9F9F9 !important;
}
::ng-deep .dialog-container app-table .mat-mdc-row:nth-child(odd) {
  background-color: #ffffff !important;
}
::ng-deep .dialog-container app-table .mat-mdc-row .mat-mdc-cell {
  border-bottom: 2px solid transparent;
  border-top: 2px solid transparent;
}
::ng-deep .dialog-container app-table .mat-mdc-cell {
  padding: 3px 6px !important;
  font-size: 11.5px !important;
  line-height: 13px !important;
  color: #3f3f3f !important;
  word-wrap: break-word;
}`, "",{"version":3,"sources":["webpack://./src/app/auto-cx/components/auto-cx-confirm/auto-cx-confirm.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,sBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAGE;;EAEE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8EAAA;AAAJ;AAGE;;EAEE,mBAAA;EACA,qBAAA;AADJ;AAIE;;EAEE,aAAA;AAFJ;AAKE;EACE,gBAAA;AAHJ;AAME;EACE,sBAAA;AAJJ;AAOE;;EAEE,2BAAA;AALJ;AAQE;EACE,oBAAA;AANJ;AASE;EACE,mBAAA;EACA,4BAAA;EACA,oDAAA;AAPJ;AAUE;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AARJ;AAWE;EACE,cAAA;AATJ;;AAaA;EACE,cAAA;EACA,eAAA;AAVF;;AAaA;EACE,6BAAA;AAVF;;AAaA;;EAEE,4BAAA;EACA,qBAAA;AAVF;;AAaA;EACE,gBAAA;AAVF;;AAaA;EACE,gBAAA;AAVF;;AAaA;EACE,WAAA;EACA,2BAAA;AAVF;;AAaA;EACE,sBAAA;EACA,YAAA;EACA,8DAAA;EACA,eAAA;AAVF;;AAaA;EACE,2BAAA;EACA,0BAAA;AAVF;;AAaA;EACE,wBAAA;AAVF;;AAaA;;EAEE,qBAAA;AAVF;;AAaA;;EAEE,aAAA;AAVF;;AAaA;EACE,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,0BAAA;EACA,oCAAA;EACA,yBAAA;AAVF;;AAaA;EACE,uBAAA;AAVF;;AAaA;EACE,0CAAA;AAVF;;AAaA;EACE,eAAA;EACA,WAAA;EACA,iBAAA;AAVF;;AAaA;EACE,aAAA;AAVF;;AAaA;EACE,4BAAA;EACA,iCAAA;EACA,2BAAA;EACA,6BAAA;EAEA,2BAAA;EACA,qBAAA;EACA,gCAAA;AAXF;AAaE;EACE,UAAA;AAXJ;AAcE;EACE,mBAAA;AAZJ;AAeE;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;AAbJ;AAeI;EACE,mBAAA;AAbN;;AAkBA,yCAAA;AAEE;EACE,uBAAA;EACA,mCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;EACA,MAAA;EACA,uBAAA;AAhBJ;AAmBE;EACE,2BAAA;EACA,mCAAA;EACA,yBAAA;EACA,oCAAA;EACA,gBAAA;EACA,MAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AAjBJ;AAmBI;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,QAAA;EACA,WAAA;EACA,QAAA;AAjBN;AAqBM;EACE,mCAAA;AAnBR;AAwBE;EACE,uBAAA;AAtBJ;AAwBI;EACE,oCAAA;AAtBN;AAyBI;EACE,oCAAA;AAvBN;AA0BI;EACE,oCAAA;EACA,iCAAA;AAxBN;AA4BE;EACE,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,yBAAA;EACA,qBAAA;AA1BJ","sourcesContent":[".dialog-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 8px;\n  min-height: 100%;\n  max-height: 100%;\n  box-sizing: border-box;\n  padding: 14px 18px 10px;\n  overflow: hidden;\n}\n\n.message-content {\n  color: rgb(73, 73, 73);\n  display: block;\n  padding: 0;\n  text-align: center;\n  line-height: 1.35;\n  word-break: break-word;\n  margin-top: -2px;\n}\n\n.action-container {\n  width: 100%;\n  padding-top: 4px;\n}\n\n.dialog-container .action-container {\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.header {\n  padding: 0 8px;\n  text-align: center;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.25;\n  color: #3f3f3f !important;\n}\n\n.dialog-body {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  padding-right: 4px;\n}\n\n.reason-field {\n  width: 100%;\n}\n\n.reason-field textarea {\n  resize: vertical;\n}\n\n::ng-deep .reason-field {\n  .mat-mdc-text-field-wrapper,\n  .mdc-text-field--filled:not(.mdc-text-field--disabled) {\n    background: #f7f8fa;\n    border: 1px solid #e1e5ea;\n    border-radius: 6px;\n    padding: 2px 10px 0;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n  }\n\n  .mat-mdc-text-field-wrapper:hover,\n  .mdc-text-field--filled:not(.mdc-text-field--disabled):hover {\n    background: #f7f8fa;\n    border-color: #cfd6df;\n  }\n\n  .mat-mdc-form-field-focus-overlay,\n  .mdc-line-ripple {\n    display: none;\n  }\n\n  .mat-mdc-form-field-flex {\n    min-height: 92px;\n  }\n\n  .mat-mdc-form-field-infix {\n    padding: 22px 8px 12px;\n  }\n\n  .mdc-floating-label,\n  .mdc-floating-label--float-above {\n    transition: none !important;\n  }\n\n  .mdc-floating-label {\n    left: 8px !important;\n  }\n\n  .mdc-text-field--focused {\n    background: #ffffff;\n    border-color: var(--primary);\n    box-shadow: 0 0 0 3px rgba(var(--primary-rgb), 0.12);\n  }\n\n  .mat-mdc-input-element {\n    color: #242424;\n    line-height: 1.35;\n    padding-left: 0;\n  }\n\n  .mat-mdc-input-element::placeholder {\n    color: #7a7f87;\n  }\n}\n\n.dialog-container mat-accordion {\n  display: block;\n  margin-top: 4px;\n}\n\n.dialog-container mat-expansion-panel {\n  border-radius: 6px !important;\n}\n\n::ng-deep .mat-expansion-panel-content,\n::ng-deep .mat-expansion-panel-body {\n  overflow: visible !important;\n  padding: 0 !important;\n}\n\n.panel-header {\n  font-weight: 400;\n}\n\n.section-header {\n  font-weight: 600;\n}\n\n.expansion-icon {\n  width: 20px;\n  color: var(--primary-light);\n}\n\n.mat-expansion-panel-header {\n  color: rgb(85, 85, 85);\n  height: 24px;\n  --mat-expansion-header-collapsed-state-height: 24px !important;\n  font-size: 15px;\n}\n\n.mat-expansion-panel-header-title .material-icons {\n  color: var(--primary-light);\n  font-size: 20px !important;\n}\n\n.mat-expanded>mat-expansion-panel-header .mat-expansion-panel-header-title .material-icons {\n  transform: rotate(90deg);\n}\n\n.mat-expansion-panel-header-title .open,\n.mat-expanded .mat-expansion-panel-header-title .close {\n  display: inline-block;\n}\n\n.mat-expanded .mat-expansion-panel-header-title .open,\n.mat-expansion-panel-header-title .close {\n  display: none;\n}\n\n.btn-footer {\n  color: var(--primary);\n  background: transparent;\n  border-radius: 4px;\n  cursor: pointer;\n  z-index: 5;\n  margin: 0;\n  padding: 0 16px;\n  font-size: 16px !important;\n  text-transform: uppercase !important;\n  transition: all 0.2s ease;\n}\n\n.btn-footer .mdc-button__label {\n  text-transform: inherit;\n}\n\n.btn-footer:hover {\n  background: rgba(var(--primary-rgb), 0.05);\n}\n\n::ng-deep .dialog-container app-table .table-container {\n  margin: 8px 0 0;\n  width: 100%;\n  padding-bottom: 0;\n}\n\n::ng-deep .dialog-container app-table .table-action-container {\n  margin-top: 0;\n}\n\n::ng-deep .dialog-container app-table .table {\n  max-height: 400px !important;\n  /* Move scroll inside the table */\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n\n  /* Thin Scrollbar Styling */\n  scrollbar-width: thin;\n  scrollbar-color: #c1c1c1 #f1f1f1;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 3px;\n    cursor: pointer;\n\n    &:hover {\n      background: #a8a8a8;\n    }\n  }\n}\n\n/* Standardized Sticky Header for Table */\n::ng-deep .dialog-container app-table {\n  .mat-mdc-header-row {\n    height: 22px !important;\n    font: 600 11px/13px Lato !important;\n    background-color: #d9d9d9 !important;\n    color: #4a4a4a !important;\n    position: sticky !important;\n    top: 0;\n    z-index: 100 !important;\n  }\n\n  th.mat-mdc-header-cell {\n    padding: 0px 5px !important;\n    font: 600 11px/13px Lato !important;\n    color: #4a4a4a !important;\n    background-color: #d9d9d9 !important;\n    position: sticky;\n    top: 0;\n    z-index: 100;\n    overflow: hidden;\n    vertical-align: middle;\n\n    &:after {\n      content: \"\";\n      border-right: 1px solid rgb(201, 201, 201);\n      position: absolute;\n      display: block;\n      height: calc(100% - 10px);\n      top: 5px;\n      bottom: 0px;\n      right: 0;\n    }\n\n    &:last-child {\n      &::after {\n        border-right: 1px solid transparent;\n      }\n    }\n  }\n\n  .mat-mdc-row {\n    height: 12px !important;\n\n    &:nth-child(even) {\n      background-color: #F9F9F9 !important;\n    }\n\n    &:nth-child(odd) {\n      background-color: #ffffff !important;\n    }\n\n    .mat-mdc-cell {\n      border-bottom: 2px solid transparent;\n      border-top: 2px solid transparent;\n    }\n  }\n\n  .mat-mdc-cell {\n    padding: 3px 6px !important;\n    font-size: 11.5px !important;\n    line-height: 13px !important;\n    color: #3f3f3f !important;\n    word-wrap: break-word;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
